import { render, staticRenderFns } from "./CharacterTalents.vue?vue&type=template&id=155ceefb&"
import script from "./CharacterTalents.vue?vue&type=script&lang=js&"
export * from "./CharacterTalents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports